import React from "react";
import Chips from "../../Chips";

import { IProps } from ".";
import { getWinClassName, betGroupProp } from "@/modules/commonMobile";
import { assetImg } from "@/modules/moduleImporter";

interface IM23Props extends IProps {
    dragonGroupWins: any;
    tigerGroupWins: any;
    dragonValue: number;
    tigerValue: number;
    checkTieWin: boolean;
}

export default class M23Portrait extends React.Component<IM23Props> {
    render() {
		const portraitGroupText = [["Black", "Red"], ["Big", "Small"], ["Odd", "Even"]];
		const portraitGroupBetKeys = [["-black", "-red"], ["-big", "-small"], ["-odd", "-even"]];
        const portraitGroupBetTypes = [["1:1", "1:1"], ["1:1", "1:1"], ["1:1", "1:1"]];

		const JSXDragonImg = assetImg("m23", "dragon"),
			JSXTigerImg = assetImg("m23", "tiger");

            const gwcn = getWinClassName;
        
        const { dragonValue, tigerValue, checkTieWin, win } = this.props;

        let portraitDragonGroupWins = [],
            portraitTigerGroupWins = [];

        if (win && win.dragon && win.tiger) {
            const gwd = this.props.dragonGroupWins,
				gwt = this.props.tigerGroupWins;

			portraitDragonGroupWins = [[gwd[0], gwd[1]], [gwd[2], gwd[3]], [gwd[4], gwd[5]]];
            portraitTigerGroupWins = [[gwt[0], gwt[1]], [gwt[2], gwt[3]], [gwt[4], gwt[5]]];
        }


        return (
            this.props.completeTable ? (
                <div className="sl-table m23 full_v3">
                    <div className="row">
                        <div className={"sl-bet col-40p taller sl-baccarat-bet-blue blue" + gwcn(win && (dragonValue > tigerValue))}
                            {...betGroupProp(this, "dragon", "dragon")}
                            // bet="dragon" group="dragon" pcode={this.props.pcode}
                            onClick={this.props.insertBet}>
                            <div>Dragon</div>
                            {JSXDragonImg}
                            <div className="bet-type">1:1</div>
                            <Chips betKey="dragon+dragon" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
                        </div>

                        <div className={"sl-bet col-20p taller sl-baccarat-bet-blue green" + gwcn(checkTieWin)}
                            {...betGroupProp(this, "tie", "tie")}
                            // bet="tie" group="tie" pcode={this.props.pcode}
                            onClick={this.props.insertBet}>
                            <div>Tie</div>
                            <div className="bet-type">8:1</div>
                            <Chips betKey="tie+tie" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
                        </div>

                        <div className={"sl-bet col-40p taller sl-baccarat-bet-blue red" + gwcn(win && (dragonValue < tigerValue))}
                            {...betGroupProp(this, "tiger", "tiger")}
                            // bet="tiger" group="tiger" pcode={this.props.pcode}
                            onClick={this.props.insertBet}>
                            <div>Tiger</div>
                            {JSXTigerImg}
                            <div className="bet-type">1:1</div>
                            <Chips betKey="tiger+tiger" mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
                        </div>
                    </div>

                    {
                        portraitGroupText.map((group, groupIdx) => (
                            <div key={"portraitGroupText_group_" + groupIdx} className="row">
                                {
                                    group.map((item, itemIdx) => {
                                        const bet = "dragon" + portraitGroupBetKeys[groupIdx][itemIdx];
                                        const betKey = bet + "+n50";

                                        return (
                                            <div key={"portraitGroupText_blue_" + betKey}
                                                className={"sl-bet col-xs-3 sl-baccarat-bet-blue blue" + gwcn(win && portraitDragonGroupWins[groupIdx][itemIdx])}
                                                {...betGroupProp(this, bet, "n50")}
                                                // bet={bet} group="n50" pcode={this.props.pcode}
                                                onClick={this.props.insertBet}>
                                                <div>{item}</div>
                                                <div className="bet-type">
                                                    {portraitGroupBetTypes[groupIdx][itemIdx]}
                                                </div>
                                                <Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
                                            </div>);
                                    })
                                }

                                {
                                    group.map((item, itemIdx) => {
                                        const bet = "tiger" + portraitGroupBetKeys[groupIdx][itemIdx];
                                        const betKey = bet + "+n50";

                                        return (
                                            <div key={"portraitGroupText_red_" + betKey}
                                                className={"sl-bet col-xs-3 sl-baccarat-bet-blue red" + gwcn(win && portraitTigerGroupWins[groupIdx][itemIdx])}
                                                {...betGroupProp(this, bet, "n50")}
                                                // bet={bet} group="n50" pcode={this.props.pcode}
                                                onClick={this.props.insertBet}>
                                                <div>{item}</div>
                                                <div className="bet-type">
                                                    {portraitGroupBetTypes[groupIdx][itemIdx]}
                                                </div>
                                                <Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
                                            </div>);
                                    })
                                }
                            </div>
                        ))
                    }
                </div>
            ) : (
                    <div className="sl-table m23 simpler">
                        <div className="row">
                            <div className={"sl-bet col-40p taller sl-baccarat-bet-blue blue" + gwcn(win && (dragonValue > tigerValue))}
                                // bet="dragon" group="dragon" pcode={this.props.pcode}
                                {...betGroupProp(this, "dragon", "dragon")}
                                onClick={this.props.insertBet}>
                                <div>Dragon</div>
                                {JSXDragonImg}
                                <div className="bet-type">1:1</div>
                                <Chips mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} betKey="dragon+dragon" />
                            </div>

                            <div className={"sl-bet col-20p taller sl-baccarat-bet-blue green" + gwcn(checkTieWin)}
                                // bet="tie" group="tie" pcode={this.props.pcode}
                                {...betGroupProp(this, "tie", "tie")}
                                onClick={this.props.insertBet}>
                                <div>Tie</div>
                                <div className="bet-type">8:1</div>
                                <Chips mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} betKey="tie+tie" />
                            </div>

                            <div className={"sl-bet col-40p taller sl-baccarat-bet-blue red" + gwcn(win && (dragonValue < tigerValue))}
                                // bet="tiger" group="tiger" pcode={this.props.pcode}
                                {...betGroupProp(this, "tiger", "tiger")}
                                onClick={this.props.insertBet}>
                                <div>Tiger</div>
                                {JSXTigerImg}
                                <div className="bet-type">1:1</div>
                                <Chips mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} betKey="tiger+tiger" />
                            </div>
                        </div>
                    </div>
                )
        );
    }
}